import React, { useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import { useInterval } from 'react-use'
import { Spinner } from 'transfix-ui/components/Spinner'
import { BooleanParam, StringParam } from 'use-query-params'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'
import { IRateConfirmationParams } from 'apps/fleet-planner/types/mobileApp'
import * as Apis from 'apps/fleet-planner/utils/api'
import { useQueryParams } from 'utils/hooks'
import { FleetPlannerLoading } from './FleetPlannerLoading'
import { TimeOutIllustration } from './TimeOutIllustration'

interface IExternalLoadParams extends IRateConfirmationParams {
  origin?: string
}

const EXTERNAL_LOAD_SYNC_INTERVAL = 2000 // 2 sec

export const ExternalLoad = () => {
  const { trackEvent } = useFMSAnalytics()
  const [errors, setErrors] = useState<string | undefined>()
  const { externalLoadId } = useParams<{ externalLoadId: string }>()
  const history = useHistory()
  const { isMobile } = useBreakpointContext()
  const [{ mobileApp, origin }] = useQueryParams<IExternalLoadParams>({
    origin: StringParam,
    mobileApp: BooleanParam,
  })

  // Fetch FP's load id for a given external load id (returns undefined if not existing)
  const getExternalShipmentFleetPlannerId = async (): Promise<string | undefined> => {
    try {
      const res = await Apis.fetchExternalLoadFleetPlannerId(externalLoadId!)
      return res.shipmentId
    } catch (e) {
      setErrors(e)
      if (mobileApp) {
        ReactNativeWebView.postMessage('ERROR')
      }
      return undefined
    }
  }

  // Will poll the API for a shipment id and will redirect once it has it
  useInterval(async () => {
    const shipmentId = await getExternalShipmentFleetPlannerId()
    if (shipmentId) {
      const loadRoute = isMobile ? 'load' : 'loads'
      const importQueryParam = origin === 'marketplace' ? '' : '?imported=true'

      if (mobileApp) {
        ReactNativeWebView.postMessage(`SIGNED,${shipmentId}`)
        return
      }

      const route =
        origin === 'rateConfirmation'
          ? `/${loadRoute}/${shipmentId}/post-truck${importQueryParam}`
          : `/${loadRoute}/${shipmentId}${importQueryParam}`
      history.push(route)
    }
    trackEvent('Marketplace Load', 'EXTERNAL_LOAD_IMPORT_SUCCESS')
  }, EXTERNAL_LOAD_SYNC_INTERVAL)

  return (
    <div className='tc vertically-center-column center'>
      {/** Check if externalLoadId is true else show TimeOutIllustration */}
      {externalLoadId ? (
        <>
          <FleetPlannerLoading />
          {errors && errors}
        </>
      ) : (
        <>
          {!(origin === 'marketplace') && (
            <>
              <TimeOutIllustration />
              <h3 className='mv6'>Your booking is confirmed!</h3>
            </>
          )}
          <div className='body-medium mb5 flex items-center external-load-body'>
            Opening your load in just a moment...
          </div>
          <Spinner position='relative' />
          {errors && errors}
        </>
      )}
    </div>
  )
}
